import { faCheck, faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import {
  WORK_INSTRUCTION_DOCUMENT_TYPES,
  WORK_INSTRUCTION_REPORT_UNITS_VERBOSE,
  WORK_INSTRUCTION_TYPES,
} from 'src/utils/constants';
import { isInstructionAnswered } from 'src/utils/maintenance';
import truncateMiddle from 'src/utils/truncateMiddle';
import isViewableDocument from 'src/utils/viewableDocument';

const NoneValue = () => <span className='mnt-report__none'>None</span>;

const unitSuffix = unit => (unit ? ` ${WORK_INSTRUCTION_REPORT_UNITS_VERBOSE[unit] || unit}` : '');

const InstructionAnswer = ({ instruction, value, file, onViewFile }) => {
  const type = instruction.reportType;

  if (WORK_INSTRUCTION_DOCUMENT_TYPES.includes(type)) {
    if (!file) return <NoneValue />;
    const viewable =
      Boolean(file.uri && onViewFile) && (!file.filename || isViewableDocument(file.filename));
    return (
      <button
        type='button'
        className='mnt-answer-file'
        disabled={!viewable}
        onClick={viewable ? () => onViewFile(file) : undefined}
      >
        <FontAwesomeIcon icon={faPaperclip} /> {truncateMiddle(file.filename || 'View file', 26)}
      </button>
    );
  }

  if (type === WORK_INSTRUCTION_TYPES.NO_ENTRY) {
    return value === true ? (
      <span className='text-success'>
        <FontAwesomeIcon icon={faCheck} /> Acknowledged
      </span>
    ) : (
      <NoneValue />
    );
  }

  if (type === WORK_INSTRUCTION_TYPES.CHECKBOX) {
    if (value === true) {
      return (
        <span className='text-success'>
          <FontAwesomeIcon icon={faCheck} /> Yes
        </span>
      );
    }
    if (value === false) return <>No</>;
    return <NoneValue />;
  }

  if (type === WORK_INSTRUCTION_TYPES.RANGE) {
    if (isInstructionAnswered(WORK_INSTRUCTION_TYPES.RANGE, value)) {
      return (
        <>
          {value[0]}-{value[1]}
          {unitSuffix(instruction.reportUnits)}
        </>
      );
    }
    return <NoneValue />;
  }

  if (value == null || value === '') return <NoneValue />;

  if (type === WORK_INSTRUCTION_TYPES.NUMBER) {
    return (
      <>
        {value}
        {unitSuffix(instruction.reportUnits)}
      </>
    );
  }

  // Long free-text answers read badly right-aligned in a narrow column —
  // render them as a full-width note block under the question instead.
  const text = String(value);
  if (text.length > 28) return <span className='mnt-answer-note'>{text}</span>;
  return text;
};

InstructionAnswer.propTypes = {
  instruction: PropTypes.object.isRequired,
  value: PropTypes.any,
  file: PropTypes.object,
  onViewFile: PropTypes.func,
};

InstructionAnswer.defaultProps = { value: null, file: null, onViewFile: null };

export default InstructionAnswer;
